// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconSystemlink } from '@ni/nimble-components/dist/esm/icons/systemlink';
import { wrap } from '../utilities/react-wrapper';

export { type IconSystemlink };
export const NimbleIconSystemlink = wrap(IconSystemlink);